module.exports = __webpack_public_path__ + "media/images/ajax-loader-large-c1fa8ab7.gif";